import type {
  DemoDataResetMembershipSelection,
  DemoDataResetRequest,
} from "../../../../../../../../../../../../../../../../../api/kehrblatt/demo-data"
import type { DemoResetMemberOutput } from "../../../../../_shared/_logic/demo-data-reset-contract"

const membershipSelection = (member: DemoResetMemberOutput): DemoDataResetMembershipSelection => ({
  membership_id: member.membershipId,
  membership_revision: member.membershipRevision,
})

/**
 * The selected memberships with the reset scope the workflow has always applied: today's base
 * date, the demo planning settings and branding, the KehrTalk plan and no calendar projection.
 */
export const buildDemoResetRequest = (
  primary: DemoResetMemberOutput,
  secondary: DemoResetMemberOutput,
): DemoDataResetRequest => ({
  primary: membershipSelection(primary),
  secondary: membershipSelection(secondary),
  base_date: null,
  reset_settings: true,
  target_plan_family: "kehrtalk",
  calendar_projection: false,
})
